const nippleRetractionProcessor=(element)=>
{let assembledElement = ""
if (element["Side"] !== "")
    {
    assembledElement += ` ${(element["Side"]).toLowerCase()}`
    }
assembledElement += " nipple retraction"

if (element["Surrounding_inflammation"] !== "")
    {
    assembledElement += ` ${(element["Surrounding_inflammation"] === "Yes" ? " with" : " without")} surrounding inflammation`
    }

if (element["Underlying_lump"] !== "")
{
assembledElement += ` ${(element["Surrounding_inflammation"] === "" ? "" : " and")}`

assembledElement += ` ${(element["Underlying_lump"] === "Yes" ? " with" : " without")} an underlying lump`

if (element["Present_for_several:"] !== "")
    {
    assembledElement += ` for several ${ (element["Present_for_several:"]).toLowerCase()}`
    }
}


return (assembledElement)
}

export default nippleRetractionProcessor